module.exports = __webpack_public_path__ + "img/statuswappbanner.6ee8e5f8.png";